import { RootState } from '../@types/RootState';

export const selectorUser = (state: RootState) => {
  return state.clienteDataReducer?.clienteData;
};

export const selectorUserLoadFinished = (state: RootState) => {
  return Boolean(state.clienteDataReducer?.clienteDataLoadFinished);
};
